module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgBjZK9DcIwEIXvTCJBxwgZIWxAaipGSE3FJClQahcMQIUi0WQEPApdkGIUfMaREvuMcpX1/D7dL4CJWt5zWBCVvG0r2WT0xsu12SNgCwiq77viXB5fMShNNy0MkKP+7ITWb2V0RQJ9kOEfRN5TeVCCMvS6K2KwDzmvKXBqSIwBjMGVTboPja1gUNIEtiIDBWAA/yKAKARwgZF3TPYH4eScWxXGoHF6/sBmw+Gg0cBNm/5sjzGIgtuzzUh3OiSrJ0SmN2vFZV6LNLMi3St3ahxcy4dd0xe3PauvY6fzBgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmark.png
// module id = X+Z/
// module chunks = 1